import { useCallback } from 'react'

import { ReportStatusIndicator } from 'app/components/common/reports/v3/ReportStatusIndicator'
import { useReportResult } from 'app/dataProviders/reports/hooks'
import { ReportType } from 'app/dataTypes/reports'
import { ReportSection, Stub, ReportDetailsRoot } from 'app/common/templates-next/report-template'
import { Loading } from 'app/common/templates-next/page-template'

import { HeaderBar } from './HeaderBar'
import { AverageCheckTable } from './AverageCheckTable'

export const Result = ({
  reportId,
  onReportId,
}: {
  reportId: null | string
  onReportId: (reportId: string | null) => void
}) => {
  const resetReport = useCallback(() => {
    onReportId(null)
  }, [onReportId])

  const { requestResult, data, loading } = useReportResult(reportId, ReportType.AverageCheck)

  const header = !reportId ? '' : 'Отчет «Средний чек»'
  const reportReady = !!data && !loading
  const isStub = !data && !reportId
  const isLoading = loading && !!reportId

  return (
    <ReportSection
      header={header}
      headerBar={<HeaderBar reportId={reportId} reportReady={reportReady} />}
      fullscreenEnabled={reportReady}
      skipPadding
    >
      {isStub && <Stub />}

      {isLoading && <Loading />}

      {reportId && (
        <ReportStatusIndicator reportID={reportId} onFail={resetReport} onSuccess={requestResult} />
      )}

      {data && (
        <ReportDetailsRoot header={'Детализация отчета «Средний чек»'}>
          <AverageCheckTable data={data} pending={loading} />
        </ReportDetailsRoot>
      )}
    </ReportSection>
  )
}
